import React from 'react';
import {
  AvailabilityMap,
  ItemListOption,
  ItemListOptionMetadata,
} from '@/contexts/item-context-types';
import { BORDER } from '@/styles';
import { OrderableItemListItemActions } from '@/components/orders/orderable-item-list-item-actions';
import { OrderGuideInfo } from '@/components/orders/order-guide-info';
import { QuantityStateType } from '@/screens/new-order/hooks/use-quantity-reducer';
import { RenderActionsFn } from '@/components/orders/item-detail-actions';
import { UpdateQuantityFn } from '@/contexts/new-order-actions-context-types';
import { VariantPackOrderInfo } from '@/components/orders/variant-pack-order-info';
import { View } from 'react-native';

interface Props {
  availabilityMap?: AvailabilityMap;
  canDecrementToZero?: boolean;
  disabled?: boolean;
  disableTextInput?: boolean;
  inDraggableSheet?: boolean;
  isFocused: boolean;
  metadata: ItemListOptionMetadata;
  onOptionsPress: (option: ItemListOption) => void;
  option: ItemListOption;
  quantityState?: QuantityStateType;
  renderActions?: RenderActionsFn;
  renderLastOrderedMessage: boolean;
  renderOrderGuideButton?: (variantPackUUID: string) => React.ReactNode;
  renderParLevels: boolean;
  renderSalesRepContent?: (
    skuMetadata: ItemListOptionMetadata,
  ) => React.ReactNode;
  sampleRequestButton?: React.ReactNode;
  shouldHideSampleRequest: boolean;
  showTooltipOnMount?: boolean;
  showVariantPackOrderInfo?: boolean;
  skus: ItemListOptionMetadata[];
  updateQuantity?: UpdateQuantityFn;
}

export const SingleOptionOrderableItem: React.FC<Props> = ({
  availabilityMap,
  canDecrementToZero,
  disabled,
  disableTextInput,
  showVariantPackOrderInfo,
  metadata,
  renderLastOrderedMessage,
  renderParLevels,
  renderOrderGuideButton,
  renderSalesRepContent,
  inDraggableSheet,
  isFocused,
  onOptionsPress,
  quantityState,
  renderActions,
  showTooltipOnMount,
  option,
  skus,
  updateQuantity,
  shouldHideSampleRequest,
  sampleRequestButton,
}) => {
  return (
    <>
      {showVariantPackOrderInfo ? (
        <VariantPackOrderInfo variantPackMetadata={metadata} />
      ) : (
        <OrderGuideInfo
          isLastOrderedMessageVisible={renderLastOrderedMessage}
          isParLevelsVisible={renderParLevels}
          orderGuidePartitionUUID={metadata.orderGuidePartitionUUID}
          variantPackUUID={metadata.variantPackUUID}
        />
      )}
      <View style={BORDER.primary}>
        <OrderableItemListItemActions
          canDecrementToZero={canDecrementToZero}
          disabled={disabled}
          disableTextInput={disableTextInput}
          inDraggableSheet={inDraggableSheet}
          isFocused={isFocused}
          onPress={() => onOptionsPress(option)}
          quantityInStock={availabilityMap?.[metadata.variantPackUUID]}
          quantityState={quantityState}
          renderActions={renderActions}
          renderOrderGuideButton={renderOrderGuideButton}
          showTooltipOnMount={showTooltipOnMount}
          skus={skus}
          updateQuantity={updateQuantity}
        />
        {renderSalesRepContent?.(metadata)}
      </View>
      {shouldHideSampleRequest || !sampleRequestButton
        ? null
        : sampleRequestButton}
    </>
  );
};
